import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { Params, RouterLink } from '@angular/router';

@Component({
  imports: [
    CommonModule,
    RouterLink,
  ],
  selector: 'app-menu-banner',
  styleUrls: ['./menu-banner.component.scss'],
  templateUrl: './menu-banner.component.html',
})
export class MenuBannerComponent {
  bannerUrl = input('');
  buttonAction = output<Event>();
  buttonHref = input('');
  buttonLabel = input('');
  description = input('');
  disabled = input(false);
  imageHeight = input(100);
  imageUrl = input('');
  internalLink = computed(() => this.buttonHref().startsWith('/'));
  loading = input(false);
  preventDefault = input(false);
  queryParams = input<Params>({});
  stopPropagation = input(false);
  title = input('');

  protected triggerAction(event: Event): void {
    if (this.preventDefault()) {
      event?.preventDefault();
    }
    if (this.stopPropagation()) {
      event?.stopPropagation();
    }
    if (this.disabled() || this.loading()) {
      return;
    }
    this.buttonAction.emit(event);
  }
}
